import React from "react";
import { Typography } from "@mui/material";

const NoDataLabel = ({ fontSize = "1rem", textAlign }) => {
  const labelAlign = textAlign ?? "center";
  return (
    <Typography fontSize={fontSize} textAlign={labelAlign}>
      No Data To Show
    </Typography>
  );
};
export default NoDataLabel;
